import axios from 'axios';

function currentTenant() {
    const [, maybe] = window.location.pathname.split('/');
    return maybe || null;
}

const dumpPipelineApi = axios.create({
    baseURL: process.env.REACT_APP_DUMP_PIPE_URL ?? 'http://localhost:8085',
    headers: { 'Content-Type': 'application/json' },
    timeout: 30000,
});

dumpPipelineApi.interceptors.request.use((cfg) => {
    const tenant = currentTenant();
    const token = process.env.REACT_APP_DUMP_PIPE_TOKEN;

    if (token) {
        cfg.headers = { ...cfg.headers, Authorization: `Bearer ${token}` };
    }

    if (tenant && cfg.url && !cfg.url.startsWith('http') && !cfg.url.startsWith(`/${tenant}`)) {
        const slash = cfg.url.startsWith('/') ? '' : '/';
        cfg.url = `/${tenant}${slash}${cfg.url}`;
    }

    return cfg;
});

export default dumpPipelineApi;
